import axios from "axios";
import config from "../config";

function createCdpHttpClient() {
  const instance = axios.create({
    baseURL: config.cdp.apiBaseUrl,
  });

  instance.interceptors.request.use((axiosConfig) => {
    return axiosConfig;
  });

  instance.interceptors.response.use(
    (res) => {
      return res;
    },
    (err) => {
      const { response } = err;

      if (response.data && response.data.error) {
        const { code, message, details } = response.data.error;

        return Promise.reject({
          message: message || "",
          status: response.status,
          code: code || "",
          details: details || [],
        });
      }

      return Promise.reject(err);
    }
  );

  return instance;
}

class CdpApi {
  constructor() {
    if (!this.client) {
      this.client = createCdpHttpClient();
    }
  }

  async getLinkById(id) {
    return this.client.get(`/links/${id}`);
  }

  async getEndpointLink(data) {
    return this.client.post(`/link-clicks`, data);
  }

  async getEndpointLinkByShortId(id) {
    return this.client.get(`/link-clicks/short/${id}`);
  }

  async clickEndpointLinkByShortId(data) {
    return this.client.post(`/link-clicks/short`, data);
  }

  async clickEndpointLinkByShortIdAndUtmNo(data) {
    return this.client.post(`/link-clicks/utm`, data);
  }

  async getSurveyById(id) {
    return this.client.get(`/survey/${id}`);
  }

  async getTakeQuestion(data) {
    return this.client.get(`/take-questions/get-question/${data.surveyId}/${data.lineUserId}`);
  }

  async createTakeQuestion(data) {
    return this.client.post(`/take-questions`, data);
  }

  async updateTakeQuestion(id, data, accessToken = null) {
    const Authorization = accessToken ? `Bearer ${accessToken}` : "";
    const headers = {
      Authorization,
      "Content-Type": "application/json",
    };
    return this.client.put(`/take-questions/${id}`, data, {
      headers: headers
    });
  }

  async createSurveyTracking(data) {
    /* remove code after Registration Event
    return this.client.post(`/survey-tracking`, data);
     */
    return {"message": "success"}
  }

  async getLastAnswerQuestion(lineUserId) {
    return this.client.get(`/answers-question/${lineUserId}`);
  }

  async getLastAnswerDemographic(channelId, lineUserId) {
    return this.client.get(`/demographic/answer/${channelId}/${lineUserId}`);
  }

  async getQuota(id) {
    /* remove code after Registration Event
    return this.client.get(`/take-questions/quota/${id}`);
    */
    return { "message": "success", "data" : false };
  }
}

const cdpApi = new CdpApi();

export default cdpApi;
